import { GeneralReportsSelect } from '@/components/GeneralReportsSelect';
import { useGetPopupContainer } from '@/components/ReportForm/Container/PopupContainer';
import { InputBase, LabelProps } from '@/components/ReportForm/InputBase';
import { InputBaseType } from '@/components/ReportForm/InputBase/types';
import { useTranslation } from '@/i18n';
import { FormSelectProps } from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';

export type Props<TFieldValues extends FieldValues> =
  InputBaseType<TFieldValues> & {
    createdByOfficeMemberId?: string;
  };

const InnerApReportFormInputReportNumberForExpenseField = <
  TFieldValues extends FieldValues
>({
  control,
  name,
  inputId,
  label,
  tooltip,
  hidden,
  caption,
  required = false,
  createdByOfficeMemberId,
}: Props<TFieldValues>) => {
  const containerRef = useGetPopupContainer();
  const labelProps: LabelProps = useMemo(
    () => ({ required, children: label, tooltip }),
    [required, label, tooltip]
  );
  const { t } = useTranslation();
  const rules: { required: string | boolean } = useMemo(
    () => ({ required: required ? t('required') : false }),
    [required, t]
  );
  const memorizedSelectProps = useMemo(
    (): Omit<
      FormSelectProps<TFieldValues>['selectProps'],
      'options' | 'comboBox'
    > => ({
      getPopupContainer: containerRef,
    }),
    [containerRef]
  );
  return (
    <InputBase labelProps={labelProps} description={caption} hidden={hidden}>
      <GeneralReportsSelect<TFieldValues>
        control={control}
        name={name}
        inputId={inputId}
        rules={rules}
        selectProps={memorizedSelectProps}
        createdByOfficeMemberId={createdByOfficeMemberId}
      />
    </InputBase>
  );
};

InnerApReportFormInputReportNumberForExpenseField.displayName =
  'InnerApReportFormInputReportNumberForExpenseField';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ApReportFormInputReportNumberForExpenseField = memo((props) => (
  <InnerApReportFormInputReportNumberForExpenseField {...props} />
)) as typeof InnerApReportFormInputReportNumberForExpenseField;
ApReportFormInputReportNumberForExpenseField.displayName =
  'ApReportFormInputReportNumberForExpenseField';
